import { PartialTenantCustomizations } from "src/tenantCustomizations/TenantCustomizations";

export const puukotiCustomizations: PartialTenantCustomizations = {
	tenantConfig: {
		erp: {
			enabled: true,
		},
	},
} as const;
